import React from 'react';
import './Button.scss';
import { Link } from '../link';
import classNames from 'classnames';
import Icon from '../../atoms/icon';

const GenericButton = ({
  backgroundColor = 'green', // set background and text color
  disabled = false,
  functionality, // 'link' or 'button'
  icon,
  iconThickness,
  order = 'icon-left', // 'icon-left' or 'icon-right'
  type = 'primary', // 'primary', 'secondary', ecc..
  text,
}) => {
  const className = classNames(
    'btn',
    { [`btn--${type}`]: type },
    { [`btn--${functionality}`]: functionality },
    { [`btn--${order}`]: order },
    { [`with-icon`]: !!icon },
    { [`disabled`]: !!disabled }
  );

  const primaryStyles = {
    transparent: {
      '--bg': 'transparent',
      '--cl': 'var(--petrolio-20k)',
      '--bd': '1px solid var(--petrolio-20k)',
      '--bg-hover': 'var(--petrolio-20k)',
      '--cl-hover': 'var(--bianco)',
    },
    green: {
      '--bg': 'var(--verde-turchese-saturated-darker)',
      '--cl': 'var(--petrolio-20k)',
      '--bg-hover': 'var(--verde-turchese-saturated-darker-50a)',
    },
    red: {
      '--bg': 'var(--red-10bd)',
      '--cl': 'var(--light-gray)',
      '--bg-hover': 'var(--red-main-color)',
      '--cl-hover': 'var(--light-gray)',
    },
    yellow: {
      '--bg': 'var(--yellow-10bd)',
      '--cl': 'var(--petrolio-20k)',
      '--bg-hover': 'var(--yellow-10b)',
    },
    turquoise: {
      '--bg': 'var(--verde-turchese-60a)',
      '--cl': 'var(--petrolio-20k)',
      '--bg-hover': 'var(--verde-turchese-80p)',
    },
  };

  const style = primaryStyles[backgroundColor] || null;
  const StaticIcon = icon;

  return (
    <span className={className} style={type === 'primary' ? style : null}>
      {!!icon &&
        (icon.markup ? (
          <Icon
            className={`btn__icon btn__icon--${order}`}
            icon={icon}
            thickness={iconThickness}
          />
        ) : (
          <StaticIcon
            className={`btn__icon btn__icon--${order}`}
            thickness={iconThickness}
          />
        ))}
      {text && <span className='btn__text'>{text}</span>}
    </span>
  );
};

const ButtonWithLink = ({
  backgroundColor,
  onClick,
  icon,
  iconThickness,
  href,
  order,
  text,
  title,
  target,
  type,
  disabled,
  className,
  stringBesideIcon = '',
}) => {
  return (
    <Link
      to={!disabled ? href : null}
      title={title}
      onClick={!disabled ? onClick : null}
      className={classNames('btn__link-wrapper', className)}
      target={target}
    >
      {stringBesideIcon !== '' && (
        <span className='video-item-preview__string-beside-icon'>
          {stringBesideIcon}
        </span>
      )}
      <GenericButton
        backgroundColor={backgroundColor}
        disabled={!!disabled}
        functionality='link'
        icon={icon}
        iconThickness={iconThickness}
        order={order}
        text={text}
        type={type}
      />
    </Link>
  );
};

const Button = ({
  backgroundColor,
  icon,
  order,
  text,
  type,
  onClick,
  disabled,
  className,
  style,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={!!disabled}
      className={className}
      style={style}
    >
      <GenericButton
        disabled={!!disabled}
        backgroundColor={backgroundColor}
        functionality='button'
        icon={icon}
        order={order}
        text={text}
        type={type}
      />
    </button>
  );
};

const ButtonSubmit = ({
  backgroundColor,
  icon,
  order,
  text,
  type,
  onClick,
  disabled,
  className,
  style,
  htmlFor,
  inputRole: inputType = 'submit',
  inputClassName,
}) => (
  <>
    <label
      htmlFor={htmlFor}
      disabled={!!disabled}
      className={className}
      style={style}
    >
      <GenericButton
        disabled={!!disabled}
        backgroundColor={backgroundColor}
        functionality='button'
        icon={icon}
        order={order}
        text={text}
        type={type}
      />
    </label>
    <input
      type={inputType}
      id={htmlFor}
      className={inputClassName}
      disabled={!!disabled}
    />
  </>
);

export default ButtonWithLink;

export { Button, ButtonWithLink, ButtonSubmit };
